import { render, staticRenderFns } from "./JoinBetaProgram.vue?vue&type=template&id=2f0e58d6&scoped=true&"
import script from "./JoinBetaProgram.vue?vue&type=script&lang=js&"
export * from "./JoinBetaProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e58d6",
  null
  
)

export default component.exports